// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_36F0efL9yrry3D32oXSdGn","icon":"YY4KHZdOubLQ6YNySWi7D","active":"_3xXUT5vUp-VSi6nwl5Xpd9"};